import React from "react";
import Card from "../../../../componets/Card";
import { AddonTemplateInterface } from "../../../../store/mods_factory/addonTemplatesSlice";

const _Details = ({ addonTemplate }: { addonTemplate: AddonTemplateInterface | undefined }) => {
  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Search text</h4>
        {addonTemplate?.search_text}
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Body Content</h4>
        {addonTemplate?.body}
      </Card>
    </>
  );
}

export default _Details;
